import { useEffect, useState } from 'react'
import { shouldSkipTurnstileOnClient } from '../../services/turnstile'

// The server cannot know the browser hostname. Keep the initial render
// verification-enabled and apply the host-specific decision after hydration.
const useSkipTurnstile = () => {
  const [skipTurnstile, setSkipTurnstile] = useState(false)

  useEffect(() => {
    setSkipTurnstile(shouldSkipTurnstileOnClient())
  }, [])

  return skipTurnstile
}

export default useSkipTurnstile
